import { createRouter, createWebHistory } from "vue-router";
import middlewarePipeline from "./middlewarePipeline";
import router from "@/router";
import store from "@/store";
import { postApi } from "@/run";

import Root from "./views/root/index.js";
import Login from "./views/login.js";

import NotFound from "@/views/NotFound.vue";
import TermsOfUse from "@/views/TermsOfUse.vue";

import Sign from "@/views/sign/index.vue";

const routes = [
  Root,
  Login,
  {
    path: "/terms_of_use",
    component: TermsOfUse,
  },
  {
    path: "/sign",
    component: Sign,
  },
  {
    path: "/:catchAll(.*)",
    component: NotFound,
  },
];

const createRouters = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});


const unlockBodyScroll = () => {
  const scrollY = parseInt(document.body.dataset.scrollY || "0", 10);
  document.body.style.position = "";
  document.body.style.top = "";
  document.body.style.left = "";
  document.body.style.right = "";

  // отключаем плавность только для этого вызова
  const html = document.documentElement;
  html.style.scrollBehavior = "auto";
  window.scrollTo(0, scrollY);
  html.style.scrollBehavior = "";

  document.body.removeAttribute("data-scroll-y");
  window.scrollTo(0, scrollY);
}

// createRouters.beforeEach((to, from, next) => {
//   unlockBodyScroll()
//   if (to.meta.middleware) {
//     const middleware = to.meta.middleware;

//     const context = {
//       to,
//       from,
//       next,
//       store,
//     };

//     if (store.state.main.loading) {
//       const loadPage = new Date();
//       const params = new URL(document.location).searchParams;

//       postApi("/main", {
//         loginUID: params.get("LoginUID"),
//         CalcID: params.get("CalcID"),
//       }).then((response) => {
//         if (response.status) {
//           store.commit("main/setData", response);
//           // if (to.path === '/' || to.path === '/login' || to.path === '/registration') router.push('main')
//         }


//         if (response.newUser) {
//           store.commit("main/setNewUser", response.dataNewUser);
//         }
//         store.commit("main/setLoading", false);

//         if (response.leasingId) {
//           return router.push({
//             name: 'leasing.item',
//             params: { id: response.leasingId }
//           });
//         }

//         return middleware[0]({
//           ...context,
//           next: middlewarePipeline(context, middleware, 1),
//         });
//       });
//     } else {
//       const middleware = to.meta.middleware;
//       return middleware[0]({
//         ...context,
//         next: middlewarePipeline(context, middleware, 1),
//       });
//     }
//   } else {
//     store.commit("main/setLoading", false);
//     return next();
//   }

// });


createRouters.beforeEach((to, from, next) => {
  // 1️⃣ Разблокировка прокрутки
  unlockBodyScroll();

  const context = { to, from, next, store };

  // 2️⃣ Проверяем, есть ли middleware
  if (to.meta.middleware) {
    const middleware = to.meta.middleware;

    // 3️⃣ Если данные ещё загружаются
    if (store.state.main.loading) {
      const params = new URL(document.location).searchParams;

      postApi("/main", {
        loginUID: params.get("LoginUID"),
        CalcID: params.get("CalcID"),
      }).then((response) => {
        // Сохраняем данные в store
        if (response.status) store.commit("main/setData", response);
        if (response.newUser) store.commit("main/setNewUser", response.dataNewUser);

        store.commit("main/setLoading", false);

        console.log(response.leasingId);
        

        // Редирект, если есть leasingId
        if (response.leasingId) {
          return router.push({
            name: "leasings.leasing.item",
            params: { id: response.leasingId },
          });
        }

        // Запуск первого middleware
        return middleware[0]({
          ...context,
          next: middlewarePipeline(context, middleware, 1),
        });
      });
    } else {
      // Данные уже загружены — просто запускаем middleware
      return middleware[0]({
        ...context,
        next: middlewarePipeline(context, middleware, 1),
      });
    }
  } else {
    // Middleware нет — просто продолжаем
    store.commit("main/setLoading", false);
    return next();
  }
});


export default createRouters;
